var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#8F9BB2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.363 19.969c-.585 0-1.154-.218-1.588-.615-.486-.443-.765-1.074-.765-1.73v-3.15c0-1.195.892-2.197 2.075-2.33.696-.079 1.387-.222 2.055-.426.836-.256 1.736-.034 2.349.579l1.276 1.276c2.444-1.337 4.481-3.375 5.818-5.819l-1.276-1.276c-.613-.613-.835-1.513-.579-2.348.204-.668.348-1.36.426-2.055C12.287.892 13.29 0 14.484 0h3.15c.657 0 1.288.278 1.73.764.446.488.666 1.145.605 1.803-.208 2.26-.807 4.442-1.78 6.485-.946 1.987-2.217 3.786-3.78 5.347-1.56 1.562-3.36 2.834-5.346 3.78-2.044.973-4.226 1.572-6.485 1.78-.072.007-.144.01-.215.01zm2.471-6.795c-.079 0-.159.011-.238.035-.759.233-1.545.396-2.336.485-.393.044-.69.38-.69.78v3.15c0 .222.091.428.256.578.167.152.383.224.609.203 8.48-.78 15.2-7.501 15.98-15.98.022-.227-.05-.443-.203-.61-.15-.164-.356-.255-.579-.255h-3.149c-.4 0-.735.296-.78.69-.089.79-.252 1.577-.484 2.336-.087.283-.014.585.19.79l2.078 2.077-.25.502c-1.558 3.131-4.14 5.714-7.273 7.272l-.502.25L5.386 13.4c-.148-.147-.346-.226-.552-.226z",
    transform: "translate(-375 -2984) translate(0 2581) translate(375 240) translate(0 160) matrix(-1 0 0 1 20 3)"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.029ed55422b29ba52f9fbb277c652b2e.svg";
export { ForwardRef as ReactComponent };